module.exports = "<div class=\"inflate\" [chart]=\"chart\"></div>\n"